const styles = theme => ({
    root: {
        position: 'absolute',
        left: props => props.x,
        top: props => props.y
    },
    point: {
        height: '42px',
        width: '42px',
        cursor: 'pointer'
    },
    popoverWrap: {
        backgroundColor: '#1D1D1D',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px',
        width: 'fit-content',
        maxWidth: '265px',
        borderRadius: '0',
        boxShadow: 'none',
        zIndex: 20
    },
    contentWrap: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start'
    },
    close: {
        color: '#FFC636',
        width: '40px',
        height: '40px',
        marginRight: '20px',
        cursor: 'pointer'
    },
    primary: {
        color: 'white',
        fontFamily: 'Montserrat',
        fontSize: '14px',
        margin: 0,
        lineHeight: '21px',
        letterSpacing: '0.02em',
        fontWeight: '700'
    },
    secondary: {
        color: 'white',
        fontFamily: 'Montserrat',
        fontWeight: '400',
        margin: 0,
        letterSpacing: '0.02em',
        fontSize: '14px',
        lineHeight: '21px'
    },
    color: {
        color: 'white',
        fontFamily: 'Montserrat',
        fontWeight: '400',
        margin: 0,
        letterSpacing: '0.01em',
        fontSize: '14px',
        lineHeight: '17px',
        marginTop: '10px',
        whiteSpace: 'pre'
    },
    strong: {
        color: 'white',
        fontFamily: 'Montserrat',
        fontWeight: '700',
        margin: 0,
        letterSpacing: '0.01em',
        fontSize: '14px',
        lineHeight: '17px',
        textTransform: 'uppercase'
    }
})

export default styles